import { render, staticRenderFns } from "./MappingFields.vue?vue&type=template&id=39d4a7f6&"
import script from "./MappingFields.vue?vue&type=script&lang=ts&"
export * from "./MappingFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports